export default __webpack_public_path__ + "static/us-enterprise-campaign-mtc-403ef9daa6ab2b44436ac00d94e005af.gif";